<!--  -->
<template>
  <div v-show="show">
    <div class="acvitity_foot" @click="openChat">
      <div>立即咨询<span>(享课程优惠)</span></div>
    </div>
    <BranchChat ref="branch" @hideChat="hideChat" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import wx from 'weixin-js-sdk';
import BranchChat from '@/components/branchChat/index.vue';

export default {
  components: {
    BranchChat,
  },
  data() {
    return {
      isCollect: false, // 是否收藏
      collectInfo: {}, // 当前收藏的数据
      disabled: false, // 能否点击
      show: false,
    };
  },
  props: {
    buyBtnData: {
      type: Object,
      default: () => {},
    },
    buyStatus: {
      type: Boolean,
      default: false,
    },
    cartCount: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    ...mapState(['courseBaseData', 'allAcvitity', 'userInfo']),
  },
  mounted() {},
  methods: {
    toBuy() {
      this.$emit('tobuy');
    },
    openChat() {
      if (!this.userInfo.id && this.$root.miniprogram) {
        let url = window.location.href;
        const [domain, searchParams] = url.split('?');
        if (searchParams) {
          const params = searchParams.split('&');
          const paramsMap = new Map();

          params.forEach((item) => {
            const [key, value] = item.split('=');
            console.log('key', key, value);
            if (key) {
              paramsMap.set(key, value);
            }
          });
          const entries = paramsMap.entries();
          let query = '';
          const ExcludequeryArr = ['THIRD_SESSION', 'env'];
          // eslint-disable-next-line no-restricted-syntax
          for (const [key, value] of entries) {
            if (!ExcludequeryArr.includes(key)) query += `${key}=${value}&`;
          }
          url = `${domain}?${query}`;
        } else {
          url = `${domain}`;
        }
        const redirctUrl = encodeURIComponent(
          `/subPackages/detailWebView/index?url=${encodeURIComponent(url)}`,
        );
        const path = `/subPackages/loginPage/loginPage?isHandle=1&isWebview=1&isCancelgoBack=1&redirctUrl=${redirctUrl}`;
        wx.miniProgram.redirectTo({
          url: path,
        });
        return;
      }
      if (!this.userInfo.id) {
        const { path, query } = this.$route;
        this.$router.push({ path: '/registrationLogin', query: { redirect: path, ...query } });
        return;
      }
      this.$refs.branch.show = true;
    },
    hideChat(data) {
      this.show = data;
    },
  },
};
</script>

<style lang="scss" scoped>
.acvitity_foot {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 100;
  width: 100%;
  height: calc(120px + constant(safe-area-inset-bottom));
  height: calc(120px + env(safe-area-inset-bottom));
  padding: 19px 0;
  background: #fff;
  box-shadow: 0 -4px 7px 0 rgba(0, 0, 0, 0.05);
  .disabled {
    opacity: 0.5;
  }
  > div {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 678px;
    height: 82px;
    margin: 0 auto;
    color: #fff;
    font-weight: 500;
    font-size: 29px;
    text-align: center;
    background: #ff7f41;
    border-radius: 41px;
    span {
      color: #fff;
      font-weight: 400;
      font-size: 22px;
    }
  }
}
</style>
